import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {ReservationService} from "app/services";
import {UpdateReservationBodyTypes} from "app/types/service-types/ReservationTypes";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {filterSchedules} from "./filter-schedules.slice";
import store from "../../../store";

interface UpdateScheduleStateParams {
  id: string;
  body: UpdateReservationBodyTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const updateSchedule =
    (params: UpdateScheduleStateParams) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.updateReservation(
            params.id,
            params.body
        );
        if (response.status >= 200 || response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Reservation changed successfully!' : 'Rezervimi u ndryshua me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
      }
    };

interface UpdateScheduleSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateScheduleSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/update",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
